module.exports = __webpack_public_path__ + "fonts/Roboto-400-symbols36.8feefe1.woff2";